import {
	CurrencyFieldConfiguration,
	FieldConfiguration,
	SelectFieldConfiguration,
} from '../../../api/ConfigApi';
import {
	PERIL_FIELD_NAMES,
	PERIL_FIELD_TITLES,
	PERIL_FIELD_VALUES,
} from '../data/constants';

const getPerilFields = (premiumCurrency: string) =>
	[
		{
			newline: true,
			name: PERIL_FIELD_NAMES.indemnityPerItemType,
			title: PERIL_FIELD_TITLES.indemnityPerItemType,
			width: 6,
			values: [
				PERIL_FIELD_VALUES.limited,
				PERIL_FIELD_VALUES.unset,
				PERIL_FIELD_VALUES.unlimited,
			],
			type: 'select',
			optional: false,
		} as SelectFieldConfiguration,
		{
			currency: premiumCurrency,
			name: PERIL_FIELD_NAMES.indemnityPerItem,
			title: PERIL_FIELD_TITLES.indemnityPerItem,
			width: 6,
			condition: {
				indemnityPerItemType: [PERIL_FIELD_VALUES.limited],
			},
			type: 'currency',
			optional: false,
		} as CurrencyFieldConfiguration,
		{
			newline: true,
			name: PERIL_FIELD_NAMES.indemnityPerEventType,
			title: PERIL_FIELD_TITLES.indemnityPerEventType,
			width: 6,
			values: [
				PERIL_FIELD_VALUES.limited,
				PERIL_FIELD_VALUES.unset,
				PERIL_FIELD_VALUES.unlimited,
			],
			type: 'select',
			optional: false,
		} as SelectFieldConfiguration,
		{
			currency: premiumCurrency,
			name: PERIL_FIELD_NAMES.indemnityPerEvent,
			title: PERIL_FIELD_TITLES.indemnityPerEvent,
			width: 6,
			condition: {
				indemnityPerEventType: [PERIL_FIELD_VALUES.limited],
			},
			type: 'currency',
			optional: false,
		} as CurrencyFieldConfiguration,
		{
			newline: true,
			name: PERIL_FIELD_NAMES.indemnityPerAggregateType,
			title: PERIL_FIELD_TITLES.indemnityPerAggregateType,
			width: 6,
			values: [
				PERIL_FIELD_VALUES.limited,
				PERIL_FIELD_VALUES.unset,
				PERIL_FIELD_VALUES.unlimited,
			],
			type: 'select',
			optional: false,
		} as SelectFieldConfiguration,
		{
			currency: premiumCurrency,
			name: PERIL_FIELD_NAMES.indemnityPerAggregate,
			title: PERIL_FIELD_TITLES.indemnityPerAggregate,
			width: 6,
			condition: {
				indemnityPerAggregateType: [PERIL_FIELD_VALUES.limited],
			},
			type: 'currency',
			optional: false,
		} as CurrencyFieldConfiguration,
		{
			newline: true,
			name: PERIL_FIELD_NAMES.lumpSumPaymentType,
			title: PERIL_FIELD_TITLES.lumpSumPaymentType,
			width: 6,
			values: [PERIL_FIELD_VALUES.set, PERIL_FIELD_VALUES.unset],
			type: 'select',
			optional: false,
		} as SelectFieldConfiguration,
		{
			currency: premiumCurrency,
			name: PERIL_FIELD_NAMES.lumpSumPayment,
			title: PERIL_FIELD_TITLES.lumpSumPayment,
			width: 6,
			condition: {
				lumpSumPaymentType: [PERIL_FIELD_VALUES.set],
			},
			type: 'currency',
			optional: true,
		} as CurrencyFieldConfiguration,
		{
			newline: true,
			name: PERIL_FIELD_NAMES.deductibleType,
			title: PERIL_FIELD_TITLES.deductibleType,
			width: 6,
			values: [PERIL_FIELD_VALUES.set, PERIL_FIELD_VALUES.unset],
			type: 'select',
			optional: false,
		} as SelectFieldConfiguration,
		{
			currency: premiumCurrency,
			name: PERIL_FIELD_NAMES.deductible,
			title: PERIL_FIELD_TITLES.deductible,
			width: 6,
			condition: {
				deductibleType: [PERIL_FIELD_VALUES.set],
			},
			type: 'currency',
			optional: true,
		} as CurrencyFieldConfiguration,
	] as FieldConfiguration[];

export default getPerilFields;
